<template> 
    <div class="flex locations-con">
        <div class="loc" v-for="(item, index) in items" :key="index">

        <div class="flex location">
            <checkboxitem :item="item.loc"/>
        </div>
    </div>
    </div>
</template>


<script>
import checkboxitem from "./checkboxitem"
export default {
    name: "cropfilter",
    data () {
        return {
            items : [
                {loc :"Rice"}, 
                {loc: "Mawa"},
                {loc :"Flower"},
                {loc: "Rice"},
                {loc :"Noida"}, 
                {loc: "Spring"},
                {loc: "Roti"},
                {loc: "Grass"},
            ], 
        }
    },
    components: {
        "checkboxitem": checkboxitem,
    },
}
</script>


<style lang="scss" scoped>
.locations-con{
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0px 10px
}
.location{
    column-gap: 8px;
    width: 170px;
    justify-content: start;    
}
.checkbox{
    width: 30px;
    height: 30px;
}
.v-input--selection-controls{
    margin-top: 6px;
}
.location-item{
    margin: 0px;
}
.v-application p {
    margin-top: 6px;
    font-size: 0.9rem;
    margin-bottom: 0px;
}
</style>
